<template>
  <div class="periodo-mes-wrapper">
    <v-menu
        v-model="menuAberto"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        left
        :nudge-bottom="6"
        min-width="auto"
        max-width="96vw"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
            :value="textoPeriodo"
            prepend-inner-icon="mdi-calendar-range"
            readonly
            dense
            outlined
            hide-details
            :disabled="disabled"
            :label="label"
            class="periodo-mes-field"
            v-bind="attrs"
            v-on="on"
        />
      </template>

      <v-card class="periodo-mes-card">
        <!-- Atalhos: aplicam na hora e fecham o popup -->
        <div v-if="atalhos.length" class="periodo-mes-atalhos d-flex flex-wrap align-center px-3 py-2">
          <span class="periodo-mes-titulo pa-0 mr-2">Atalhos</span>
          <v-chip
              v-for="atalho in atalhos"
              :key="atalho.label"
              small
              class="mr-1"
              :outlined="!atalhoAtivo(atalho)"
              :color="atalhoAtivo(atalho) ? 'primary' : undefined"
              @click="aplicarAtalho(atalho)"
          >
            {{ atalho.label }}
          </v-chip>
        </div>
        <v-divider v-if="atalhos.length" />
        <div class="d-flex flex-wrap justify-center periodo-mes-pickers">
          <div class="periodo-mes-coluna">
            <div class="periodo-mes-titulo">Mês inicial</div>
            <v-date-picker
                v-model="rascunhoInicio"
                type="month"
                no-title
                flat
                width="250"
                color="primary"
                :allowed-dates="mesInicialPermitido"
                :min="minMes"
                :max="maxMes"
            />
          </div>
          <v-divider vertical class="d-none d-sm-flex" />
          <div class="periodo-mes-coluna">
            <div class="periodo-mes-titulo">Mês final</div>
            <v-date-picker
                v-model="rascunhoFim"
                type="month"
                no-title
                flat
                width="250"
                color="primary"
                :allowed-dates="mesFinalPermitido"
                :min="minMes"
                :max="maxMes"
            />
          </div>
        </div>
        <v-divider />
        <v-card-actions class="px-3 py-2">
          <v-spacer />
          <v-btn small text @click="menuAberto = false">Cancelar</v-btn>
          <v-btn small color="primary" depressed :disabled="!periodoValido" @click="aplicar">Aplicar</v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
// Seletor de período por MÊS (aaaa-mm), no mesmo visual do SeletorPeriodo (que trabalha com dias)
export default {
  name: 'SeletorPeriodoMes',
  props: {
    inicio: { type: String, required: true },
    fim: { type: String, required: true },
    // limites selecionáveis (aaaa-mm)
    minMes: { type: String, default: undefined },
    maxMes: { type: String, default: undefined },
    // atalhos de período: [{ label, inicio, fim }] (aaaa-mm)
    atalhos: { type: Array, default: () => [] },
    label: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data: () => ({
    menuAberto: false,
    rascunhoInicio: null,
    rascunhoFim: null,
  }),
  computed: {
    textoPeriodo() {
      return `${this.formatar(this.inicio)}  até  ${this.formatar(this.fim)}`;
    },
    periodoValido() {
      return !!this.rascunhoInicio && !!this.rascunhoFim && this.rascunhoInicio <= this.rascunhoFim;
    },
  },
  methods: {
    // aaaa-mm -> mm/aaaa
    formatar(mes) {
      return (mes || '').split('-').reverse().join('/');
    },
    // um mês não pode passar do outro: o inicial vai até o final escolhido e o final começa no inicial escolhido
    mesInicialPermitido(mes) {
      return !this.rascunhoFim || mes <= this.rascunhoFim;
    },
    mesFinalPermitido(mes) {
      return !this.rascunhoInicio || mes >= this.rascunhoInicio;
    },
    atalhoAtivo(atalho) {
      return atalho.inicio === this.inicio && atalho.fim === this.fim;
    },
    aplicarAtalho(atalho) {
      this.rascunhoInicio = atalho.inicio;
      this.rascunhoFim = atalho.fim;
      this.aplicar();
    },
    aplicar() {
      this.menuAberto = false;
      if (this.rascunhoInicio === this.inicio && this.rascunhoFim === this.fim) return;
      this.$emit('aplicar', { inicio: this.rascunhoInicio, fim: this.rascunhoFim });
    },
  },
  watch: {
    // cada abertura começa a partir do período em vigor (descarta rascunho cancelado)
    menuAberto(aberto) {
      if (aberto) {
        this.rascunhoInicio = this.inicio;
        this.rascunhoFim = this.fim;
      }
    },
  },
};
</script>

<style scoped>
.periodo-mes-wrapper {
  width: 100%;
}

/* ===== INPUT (mesmo visual do SeletorPeriodo) ===== */
.periodo-mes-field >>> .v-input__control {
  min-height: 40px !important;
}
.periodo-mes-field >>> input {
  cursor: pointer;
  font-weight: 600;
  color: #023449;
}
.periodo-mes-field >>> fieldset {
  border-color: #cbd5e1;
  border-width: 2px;
  transition: all 0.2s ease;
}
.periodo-mes-field >>> .v-input__slot {
  background: #f8fafc;
  cursor: pointer;
  transition: all 0.2s ease;
  border-radius: 10px;
}
.periodo-mes-field >>> .v-input__prepend-inner .v-icon {
  color: #023449 !important;
  opacity: 0.7;
  transition: opacity 0.2s ease;
}
.periodo-mes-field:hover >>> .v-input__prepend-inner .v-icon {
  opacity: 1 !important;
}
.periodo-mes-field >>> .v-input__slot:hover {
  background: #ffffff;
}
.periodo-mes-field >>> .v-input__slot:hover fieldset {
  border-color: #023449;
}
.periodo-mes-field >>> .v-input--is-focused fieldset {
  border-color: #023449 !important;
  box-shadow: 0 0 0 3px rgba(2, 52, 73, 0.1);
}
.periodo-mes-field >>> .v-input--is-focused .v-input__slot {
  background: #ffffff !important;
}

/* ===== POPUP ===== */
.periodo-mes-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(2, 52, 73, 0.15) !important;
}
.periodo-mes-pickers {
  padding: 8px 4px 0;
}
.periodo-mes-coluna {
  padding: 0 6px;
}
.periodo-mes-titulo {
  padding: 6px 12px 0;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: #023449;
}
</style>
